import React from "react";
import { t } from "../multi-language/multi-lang.service";
var ECGAndPPGStrips = function (_a) {
    var af_detection_summary_data = _a.af_detection_summary_data, rtDate = _a.rtDate, isPdf = _a.isPdf;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card", style: { margin: '20px auto' } },
            React.createElement("div", { className: "card-body" },
                React.createElement("div", { className: "card-header bg-transparent", style: { padding: '0.85rem 1.5rem' } },
                    React.createElement("div", { className: "row header-card" }, "ECG and PPG Strips"),
                    React.createElement("div", null,
                        React.createElement("div", { className: "mt-2 text-lg" }, "Signal example"))),
                React.createElement("div", { className: "position-relative" },
                    rtDate && React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "p-3 ml-4" },
                            "Below you can examine the signal taken from your last spot-check taken in (",
                            rtDate,
                            ")"),
                        React.createElement("div", { className: "af-text-scale" }, t('charts.scale_text'))),
                    React.createElement("div", { className: "ecg-report-chart position-relative", key: 'ecg-report-chart' }),
                    React.createElement("div", { style: { marginTop: 30, marginLeft: 100 } },
                        "* ",
                        t('arryth_report.appendix.print_scale_text')))))));
};
export default ECGAndPPGStrips;
//# sourceMappingURL=ecg-ppg-strips.js.map